import React from "react";

const JumpTime = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="13.444" height="10.882" viewBox="0 0 13.444 10.882">
			<path
				id="icon-forward-arrow"
				d="M4.32,21.881H4.306A.319.319,0,0,1,4,21.559c0-.079.185-7.781,7.682-7.994V11.32a.32.32,0,0,1,.521-.249l5.121,4.161a.321.321,0,0,1,0,.5L12.2,19.891a.323.323,0,0,1-.34.04.319.319,0,0,1-.183-.289V17.4c-6.671.121-7.031,4.012-7.043,4.18A.319.319,0,0,1,4.32,21.881Z"
				transform="translate(-4 -10.999)"
				fill="#fff"
				opacity="0.5"
			/>
		</svg>
	);
};

export default JumpTime;
